import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory<HTMLElement>()({
  targets: {
    button: HTMLElement,
  },
  values: {
    label: String,
  },
}) {
  updateForm(event: CustomEvent): void {
    const searchParams = new URL(event.detail.fetchResponse.response.url)
      .searchParams;

    const per_page = searchParams.get("per_page") || 25;
    this.buttonTarget.innerText = this.labelValue.replace(
      "%{number}",
      String(per_page),
    );
  }
}
